<template>
	<div>
		<div class="row">
			<div class="col-md-4">
				<div class="form-group">
					<label>{{ $t("student") }}</label>
					<div class="pseudo-input mb-3">
						<input
							type="search"
							class="input-bare w-full flex-1"
							placeholder="Student"
							v-if="!localSearch.students.length"
							@click="selectStudent"
							@keyup.enter="selectStudent"
						/>
						<span
							class="badge badge-secondary badge-sm mr-2 mb-2"
							v-for="(student, index) in localSearch.students"
							:key="index"
						>
							{{ student.displayName }}
							<a @click="removeStudent(student)"><b-icon icon="x"></b-icon></a>
						</span>
						<span
							class="badge badge-primary badge-sm mr-2 mb-2"
							v-if="localSearch.students.length"
							@click="selectStudent"
							@keyup.enter="selectStudent"
							tabindex="0"
							:aria-label="$t('student') + ' ' + $t('add')"
						>
							<b-icon icon="plus"></b-icon> {{ $t("add") }}
						</span>
						<span
							class="badge badge-danger badge-sm mr-2 mb-2"
							v-if="localSearch.students.length"
							@click="localSearch.students = []; updateSearch()"
							@keyup.enter="localSearch.students = []; updateSearch()"
							tabindex="0"
							:aria-label="$t('student') + ' ' + $t('clear-all')"
						>
							<b-icon icon="x"></b-icon> {{ $t('clear-all') }}
						</span>
					</div>
				</div>
			</div>
			<div class="col-md-4">
				<div class="form-group">
					<label>{{ $t('teacher') }}</label>
					<div class="pseudo-input mb-3">
						<input
							type="search"
							class="input-bare w-full flex-1"
							placeholder="Teacher"
							v-if="!localSearch.teachers.length"
							@click="selectTeacher"
							@keyup.enter="selectTeacher"
							:aria-label="$t('teacher')"
						/>
						<span
							class="badge badge-secondary badge-sm mr-2 mb-2"
							v-for="(teacher, index) in localSearch.teachers"
							:key="index"
						>
							{{ teacher.displayName }}
							<a @click="removeTeacher(teacher)"><b-icon icon="x"></b-icon></a>
						</span>
						<span
							class="badge badge-primary badge-sm mr-2 mb-2"
							v-if="localSearch.teachers.length"
							@click="selectTeacher"
							@keyup.enter="selectTeacher"
							tabindex="0"
							:aria-label="$t('teacher') + ' ' + $t('add')"
						>
							<b-icon icon="plus"></b-icon> {{ $t("add") }}
						</span>
						<span
							class="badge badge-danger badge-sm mr-2 mb-2"
							v-if="localSearch.teachers.length"
							@click="localSearch.teachers = []; updateSearch()"
							@keyup.enter="localSearch.teachers = []; updateSearch()"
							tabindex="0"
							:aria-label="$t('teacher') + ' ' + $t('clear-all')"
						>
							<b-icon icon="x"></b-icon> {{ $t('clear-all') }}
						</span>
					</div>
				</div>
			</div>
			<div class="col-md-4">
				<div class="form-group">
					<label>{{ $t('subject') }}</label>
					<div class="pseudo-input mb-3">
						<input
							type="search"
							class="input-bare w-full flex-1"
							placeholder="Subject"
							v-if="!localSearch.subjects.length"
							@click="selectSubject"
							@keyup.enter="selectSubject"
							:aria-label="$t('subject')"
						/>
						<span
							class="badge badge-secondary badge-sm mr-2 mb-2"
							v-for="(subject, index) in localSearch.subjects"
							:key="index"
						>
							{{ subject.displayName }}
							<a @click="removeSubject(subject)"><b-icon icon="x"></b-icon></a>
						</span>
						<span
							class="badge badge-primary badge-sm mr-2 mb-2"
							v-if="localSearch.subjects.length"
							@click="selectSubject"
							@keyup.enter="selectSubject"
							tabindex="0"
							:aria-label="$t('subject') + ' ' + $t('add')"
						>
							<b-icon icon="plus"></b-icon> {{ $t("add") }}
						</span>
						<span
							class="badge badge-danger badge-sm mr-2 mb-2"
							v-if="localSearch.subjects.length"
							@click="localSearch.subjects = []; updateSearch()"
							@keyup.enter="localSearch.subjects = []; updateSearch()"
							tabindex="0"
							:aria-label="$t('subject') + ' ' + $t('clear-all')"
						>
							<b-icon icon="x"></b-icon> {{ $t('clear-all') }}
						</span>
					</div>
				</div>
			</div>
			<div class="col-md-4">
				<div class="form-group">
					<label>{{ $t('completed') }}</label>
					<select
						v-model="localSearch.completed"
						class="form-control"
						@change="updateSearch()"
					>
						<option value="">{{ $t("any") }}</option>
						<option value="y">{{ $t("completed") }}</option>
						<option value="n">{{ $t("not-completed") }}</option>
					</select>
				</div>
			</div>
			<div class="col-md-4">
				<div class="form-group">
					<label>{{ $t('reviewed') }}</label>
					<select
						v-model="localSearch.reviewed"
						class="form-control"
						@change="updateSearch()"
					>
						<option value="">{{ $t("any") }}</option>
						<option value="y">{{ $t("reviewed") }}</option>
						<option value="n">{{ $t("not-reviewed") }}</option>
					</select>
				</div>
			</div>
			<div class="col-md-4">
				<div class="form-group">
					<label>{{ $t('signed-off') }}</label>
					<select
						v-model="localSearch.signedoff"
						class="form-control"
						@change="updateSearch()"
					>
						<option value="">{{ $t("any") }}</option>
						<option value="y">{{ $t("signed-off") }}</option>
						<option value="n">{{ $t("not-signed-off") }}</option>
					</select>
				</div>
			</div>
			<div class="col-md-4">
				<MultiselectSearchInput
					:label="$t('workflows')"
					:options="workflows"
					optionValue="id"
					optionLabel="title"
					v-model="localSearch.workflows"
					@input="updateSearch()"
				/>
			</div>
			<div class="col-md-4">
				<MultiselectSearchInput
					:label="$t('form')"
					:options="forms"
					optionValue="id"
					optionLabel="title"
					v-model="localSearch.forms"
					@input="updateSearch()"
				/>
			</div>
			<div class="col-md-4" v-if="localSearch.forms.length == 1">
				<MultiselectSearchInput
					:label="$t('form-fields')"
					:options="matchingFields"
					optionValue="id"
					optionLabel="question"
					v-model="localSearch.formfields"
					@input="onFormFieldChange()"
				/>
			</div>
			<div class="col-md-4" v-if="selectedFieldType === 'select'">
				<MultiselectSearchInput
					:label="$t('field-value')"
					:options="matchingFieldOptions"
					optionValue="value"
					optionLabel="caption"
					v-model="localSearch.formfieldvalues"
					@input="updateSearch()"
				/>
			</div>
			<div class="col-md-4" v-if="selectedFieldType === 'date'">
				<div class="form-group">
					<label>{{ $t('field-value') }}</label>
					<input type="date" v-model="localSearch.formfieldvalue" class="form-control" @change="updateSearch()">
				</div>
			</div>
			<div class="col-md-4" v-if="selectedFieldType === 'text'">
				<div class="form-group">
					<label>{{ $t('field-value') }}</label>
					<input type="text" v-model="localSearch.formfieldvalue" class="form-control" @input="updateSearch()" @keyup.enter="updateSearch()">
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-md-4">
				<div class="form-group">
					<label>{{ $t("programme") }}</label>
					<select class="form-control" v-model="localSearch.programme" @change="updateSearch()">
						<option :value="null">{{ $t("any") }}</option>
						<option
							v-for="programme in $config.getValue('programmes')"
							:key="programme.Id"
							:value="programme"
						>{{ programme.Name }}</option>
					</select>
				</div>
			</div>
			<div class="col-md-4">
				<div class="form-group">
					<label>{{ $t("year") }}</label>
					<select class="form-control" v-model="localSearch.year" @change="updateSearch()">
						<option :value="null">{{ $t("any") }}</option>
						<template v-if="localSearch.programme">
							<option
								v-for="year in parseInt(localSearch.programme.CourseLengthYears)"
								:key="year"
								:value="year"
							>{{ year }}</option>
							<option :value="parseInt(localSearch.programme.CourseLengthYears) + 1">{{ $t('graduated') }}</option>
						</template>
					</select>
				</div>
			</div>
			<div class="col-md-4">
				<div class="form-group">
					<label>{{ $t("group") }}</label>
					<select class="form-control" v-model="localSearch.group" @change="updateSearch()">
						<option :value="null">{{ $t("any") }}</option>
						<option
							v-for="(name, id) in $config.getValue('groups')"
							:key="id"
							:value="id"
						>{{ name }}</option>
					</select>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-md-4">
				<div class="form-group">
					<label>{{ $t("workbook") }}</label>
					<select class="form-control" v-model="localSearch.workbookid" @change="updateSearch()">
						<option :value="null">{{ $t("any") }}</option>
						<option
							v-for="workbook in $config.getValue('workbooks')"
							:key="workbook.id"
							:value="workbook.id"
						>{{ workbook.title }}</option>
					</select>
				</div>
			</div>
			<div class="col-md-4">
				<div class="form-group">
					<label>{{ $t('from') }}</label>
					<input
						type="date"
						v-model="localSearch.date_from"
						class="form-control"
						@change="updateSearch()"
					>
				</div>
			</div>
			<div class="col-md-4">
				<div class="form-group">
					<label>{{ $t('to') }}</label>
					<input
						type="date"
						v-model="localSearch.date_to"
						class="form-control"
						@change="updateSearch()"
					>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import MultiselectSearchInput from "src/components/Inputs/MultiselectSearchInput.vue";

export default {
	components: {
		MultiselectSearchInput,
	},
	props: {
		value: {
			type: Object,
			required: true,
		},
		forms: {
			type: Array,
			default: () => [],
		},
		workflows: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			localSearch: JSON.parse(JSON.stringify(this.value)),
		};
	},
	watch: {
		value(newVal) {
			const serialized = JSON.stringify(newVal);
			if (serialized !== JSON.stringify(this.localSearch)) {
				this.localSearch = JSON.parse(serialized);
			}
		},
	},
	computed: {
		matchingFields() {
			if (this.localSearch.forms.length !== 1) return [];
			const match = this.forms.find(
				item => String(item.id) === String(this.localSearch.forms[0].id)
			);
			return match ? (match.fields || []) : [];
		},
		matchingFieldOptions() {
			if (this.localSearch.formfields.length !== 1) return [];
			return (this.localSearch.formfields[0].options || []).map(opt => ({ ...opt, id: opt.value }));
		},
		selectedFieldType() {
			if (this.localSearch.formfields.length !== 1) return null;
			const field = this.localSearch.formfields[0];
			if (field.options && field.options.length > 0) return 'select';
			if (field.type === 'date' || field.type === 'datetime') return 'date';
			return 'text';
		},
	},
	methods: {
		updateSearch() {
			this.$emit('input', JSON.parse(JSON.stringify(this.localSearch)));
		},
		selectStudent() {
			const self = this;
			this.$users.getStudents.call(this).then((students) => {
				this.$store.commit("openModal", {
					type: "selector",
					title: this.$t("select-a-student"),
					selectCallback: function (selection) {
						const isSelected = self.localSearch.students.find((student, i) => {
							if (student.id === selection.id) {
								self.$delete(self.localSearch.students, i);
								return true;
							}
						});
						if (!isSelected) {
							self.localSearch.students.push(selection);
						}
						self.updateSearch();
					},
					selected: this.localSearch.students,
					data: students,
					captionKey: "displayName",
					subcaptionKey: "studentid",
					studentSearchFilters: true,
					selectAllBtn: true,
				});
			});
		},
		removeStudent(selection) {
			this.localSearch.students.find((student, i) => {
				if (student.id === selection.id) {
					this.$delete(this.localSearch.students, i);
					this.updateSearch();
					return true;
				}
			});
		},
		selectTeacher() {
			const self = this;
			this.$users.getTeachers.call(this).then((teachers) => {
				const processedTeachers = teachers.map((teacher) => {
					if (teacher.status && teacher.status.toLowerCase() === "closed") {
						teacher.subcaption = this.$t("(Closed)");
					}
					return teacher;
				});
				this.$store.commit("openModal", {
					type: "selector",
					title: this.$t("select-a-teacher"),
					selectCallback: function (selection) {
						const isSelected = self.localSearch.teachers.find((teacher, i) => {
							if (teacher.id === selection.id) {
								self.$delete(self.localSearch.teachers, i);
								return true;
							}
						});
						if (!isSelected) {
							self.localSearch.teachers.push(selection);
						}
						self.updateSearch();
					},
					selected: this.localSearch.teachers,
					data: processedTeachers,
					captionKey: "displayName",
					subcaptionKey: "subcaption",
					selectAllBtn: true,
				});
			});
		},
		removeTeacher(selection) {
			this.localSearch.teachers.find((teacher, i) => {
				if (teacher.id === selection.id) {
					this.$delete(this.localSearch.teachers, i);
					this.updateSearch();
					return true;
				}
			});
		},
		selectSubject() {
			const self = this;
			this.$users.getStudents.call(this).then((subjects) => {
				this.$store.commit("openModal", {
					type: "selector",
					title: this.$t("select-a-subject"),
					selectCallback: function (selection) {
						const isSelected = self.localSearch.subjects.find((subject, i) => {
							if (subject.id === selection.id) {
								self.$delete(self.localSearch.subjects, i);
								return true;
							}
						});
						if (!isSelected) {
							self.localSearch.subjects.push(selection);
						}
						self.updateSearch();
					},
					selected: this.localSearch.subjects,
					data: subjects,
					captionKey: "displayName",
					studentSearchFilters: true,
					selectAllBtn: true,
				});
			});
		},
		removeSubject(selection) {
			this.localSearch.subjects.find((subject, i) => {
				if (subject.id === selection.id) {
					this.$delete(this.localSearch.subjects, i);
					this.updateSearch();
					return true;
				}
			});
		},
		onFormFieldChange() {
			this.localSearch.formfieldvalues = [];
			this.localSearch.formfieldvalue = null;
			this.updateSearch();
		},
	},
};
</script>
